export const CANVAS_PREFILL_EVENT_NAME = "pacProviderMatching.event";
